import { MessageCircle } from "lucide-react";
import { waLink, waProductMessage, getCategory } from "../data/store";

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export function ProductCard({ product }) {
  const category = getCategory(product.category);
  const Icon = category ? category.icon : null;
  return (
    <article
      data-testid={`product-card-${slugify(product.name)}`}
      className="flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-shadow duration-300 hover:shadow-md"
    >
      {product.photo ? (
        <img
          src={product.photo}
          alt={product.name}
          width="600"
          height="450"
          loading="lazy"
          className="aspect-[4/3] w-full object-cover"
        />
      ) : (
        <div className="flex aspect-[4/3] w-full items-center justify-center bg-slate-50">
          {Icon && <Icon className="h-10 w-10 text-brand/40" aria-hidden="true" />}
        </div>
      )}
      <div className="flex flex-1 flex-col p-5">
        <h3 className="text-base font-semibold text-navy">{product.name}</h3>
        {product.brand && <p className="mt-0.5 text-xs font-medium text-slate-500">{product.brand}</p>}
        {product.spec && <p className="mt-1 text-sm text-slate-600">{product.spec}</p>}
        <p className="mt-2 text-sm font-semibold text-navy">
          {product.price ? product.price : "Hubungi untuk harga"}
        </p>
        <a
          href={waLink(waProductMessage(product))}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`product-wa-${slugify(product.name)}`}
          className="mt-4 inline-flex items-center justify-center gap-2 rounded-full bg-wa px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-wa-dark"
        >
          <MessageCircle className="h-4 w-4" aria-hidden="true" />
          Tanya barang ini
        </a>
      </div>
    </article>
  );
}
